<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import _ from "lodash";
import { BaseAtom, getSignonManager } from "components/cards/atoms";
import { ButtonParticle } from "components/cards/particles/YinzCam";
import "js/url";
import { getProfileFields } from "js/profile-fields";
export let container = undefined;
export let defaultButton = undefined;
export let loggedOutButton = undefined;
export let loggedInButton = undefined;
const fields = getProfileFields();
const sso = getSignonManager();
const profile = sso.getDefaultProfileSegmentStore();
$: loginStatus = sso.getStatusComponent().store;
$: isLoggedIn = $loginStatus.loggedIn;
let currentButton = loggedOutButton;
let buttonOverrides = {};
$: if (isLoggedIn) {
    currentButton = loggedInButton;
    if ($profile === null || $profile === void 0 ? void 0 : $profile[fields.firstName]) {
        buttonOverrides = { text: { text: $profile === null || $profile === void 0 ? void 0 : $profile[fields.firstName] } };
    }
}
else {
    currentButton = loggedOutButton;
    buttonOverrides = {};
}
async function handleSignInButtonClick() {
    if (isLoggedIn) {
        //console.log('profile signed in', resolveUrl('profile'));
        //resolveUrl('profile').func();
        sso.showCompleteProfilePage();
    }
    else {
        sso.requireAuth();
    }
}
</script>

<style></style>

<BaseAtom _isotope="LoginButtonAtom" {...container}>
  <ButtonParticle {..._.merge({}, defaultButton, currentButton, buttonOverrides)} on:click={handleSignInButtonClick} />
</BaseAtom>
